import { ACTIONS } from "../../common/constants";

const screenSizeReducer = function (state = {}, action) {
    switch (action.type) {
        case ACTIONS.SET_SCREEN_SIZE:
            return action.data;
        default:
            return state;
    }
};

export default screenSizeReducer;
